/* EmptyState — centered placeholder with icon, title, description, and optional action.
   Ported from lib/components.jsx (claude_design project 5c0836b6-facf-49dd-9c78-62afe3f7bc12). */

import React from 'react';
import { Icon } from './Icon';
import type { IconName } from './Icon';

export interface EmptyStateProps {
  icon?: IconName;
  title?: React.ReactNode;
  desc?: React.ReactNode;
  action?: React.ReactNode;
}

export function EmptyState({
  icon = 'inbox',
  title,
  desc,
  action,
}: EmptyStateProps) {
  return (
    <div className="empty">
      <div className="empty-icon">
        <Icon name={icon} size={22} />
      </div>
      <div className="empty-title">{title}</div>
      {desc && <div className="empty-desc">{desc}</div>}
      {action && <div style={{ marginTop: 16 }}>{action}</div>}
    </div>
  );
}

export default EmptyState;
